(function() {
	'use strict';
	angular.module('app.core')
		.service('columnsService', columnsService);

	columnsService.$inject = ['itemColumns', 'userColumns', 'factoryColumns', 'taskColumns', 'supplyOrderColumns', 'dataPipelineColumns', 'tableRenderService'];
	/**
	 * @param Object columns 
	 * Pass an object whose keys are the ids of columns to include in the report. Each column
	 * definition will provide defaults for its configuration. The value of the each entry in
	 * the input object will be used to override these defaults.
	 * 
	 * If the value is a boolean or integer it will be used to set the default of the `show`
	 * property. Use 1 or true to show ; 0 or false to hide.
	 * 
	 * If a string is given, it will override the display default, which is the column heading. If
	 * you pass a string, the show property will be defaulted. All columns should default to be
	 * visible, so if you want to override a display heading and make hidden, use an object.
	 * 
	 * If an object is given, each of its properties will override a default setting on the column.
	 * 
	 * The special `conditional` parameter can be set to a function which will be called to include
	 * or exclude the column from the report. This function should return true to include the column,
	 * or false to exclude the column. It will receive the filterParams as its argument and its
	 * context will be the column definition itself, which it may modify.
	 * 
	 * @param Object defaultConfig (optional)
	 * Will be used to apply a default for all columns. Properties in this object will be set for
	 * all columns, but will not override properties * which are defined in the column definition.
	 * However they will override defaults which would otherwise be set by the table directive.
	 * 
	 * @param Object filterParams (optional)
	 * Any special data which might be used by a `conditional` parameter in the column definition.
	 * 
	 */
	function columnsService(itemColumns, userColumns, factoryColumns, taskColumns, supplyOrderColumns, dataPipelineColumns, tableRenderService) {
		var columnMasterList = buildMasterList([itemColumns, userColumns, factoryColumns, taskColumns, supplyOrderColumns, dataPipelineColumns]);

		function columnsServiceMap(columns, defaultConfig, filterParams) {
			return _.transform(columns, function(result, localConfig, id) {
				var masterConfig;
				localConfig = _.isObject(localConfig)
					? localConfig // object with overrides
					: _.isString(localConfig)
						? { display: localConfig } // string replaces default column heading
						: { show: !!localConfig }; // anything else as boolean for show
				masterConfig = columnMasterList.hasOwnProperty(id) ? columnMasterList[id] : {};
				result.push(_.assign({}, defaultConfig, masterConfig, localConfig));
			}, []).filter(function(column) {
				if (column.hasOwnProperty('conditional') && column.conditional) {
					return column.conditional.apply(column, [filterParams]);
				}
				return true;
			});
		};

		function buildMasterList(configs) {
			var masterList = {};
			configs.forEach(function(columns) {
				columns.forEach(function(column){
					var ids = [column.id].concat(column.aliases);
					ids.forEach(function(id){
						masterList[id] = _.assign({}, column, {id:id});
					});
				});
			});
			return masterList;
		}

		return columnsServiceMap;
	};
})();
